import { extendTheme } from '@chakra-ui/react'

import frogBoxTheme from './theme.json'

// convert textCase to textTransform
type TextStyles = { [key: string]: any } // eslint-disable-line
const textStyles: TextStyles = frogBoxTheme.typography
Object.keys(textStyles).forEach(key => {
  if (textStyles[key].textCase) textStyles[key].textTransform = textStyles[key].textCase
  if (key.match(/^[hH]\d.*/gm)) textStyles[key].lineHeight *= 1.1
})

// export Chakra theme extended with Frogbox design tokens
const theme = extendTheme({
  background: frogBoxTheme.base.colors.background,
  baseColors: frogBoxTheme.base.colors,
  baseComponents: frogBoxTheme.components,
  borders: frogBoxTheme.base.border,
  colors: frogBoxTheme.colors,
  constants: {
    viewportPadding: 16,
  },
  fontFamilies: frogBoxTheme.base.fontFamilies,
  fontSizes: frogBoxTheme.base.fontSizes,
  fontWeights: frogBoxTheme.base.fontWeights,
  gradient: frogBoxTheme.gradient,
  opacity: {
    disabled: '0.24',
    overlay: '0.64',
    full: '1.0',
  },
  radii: frogBoxTheme.base.borderRadius,
  realm: {
    0: frogBoxTheme.colors.gray['400'],
    1: frogBoxTheme.colors.blue['400'],
    2: frogBoxTheme.colors.red['400'],
    3: frogBoxTheme.colors.blue['400'],
    4: frogBoxTheme.colors.purple['400'],
  },
  shadows: frogBoxTheme.base.boxShadow,
  textStyles: textStyles,
  zIndex: {
    modal: 800,
    overlay: 600,
    menu: 500,
    content: 400,
    background: 200,
    base: 0,
  },
})

export default theme
